// Маппинг числовых значений флагов на строковые ключи
export const sportFlagsToKeys = {
  1: 'tableTennis',           // 1L << 0
  2: 'basketball',            // 1L << 1  
  4: 'volleyball',            // 1L << 2
  8: 'badminton',             // 1L << 3
  16: 'paintball',            // 1L << 4
  32: 'football',             // 1L << 5
  64: 'hockey',               // 1L << 6
  128: 'tennis',              // 1L << 7
  256: 'boxing',              // 1L << 8
  512: 'lasertag',            // 1L << 9
  1024: 'running',            // 1L << 10
  2048: 'golf',               // 1L << 11
  4096: 'pool',               // 1L << 12
  8192: 'fitness',            // 1L << 13
  16384: 'bowling',           // 1L << 14
  32768: 'driving',           // 1L << 15
  65536: 'rugby',             // 1L << 16
  131072: 'americanFootball', // 1L << 17
  262144: 'chess',            // 1L << 18
  524288: 'iceSkating',       // 1L << 19
  1048576: 'baseball',        // 1L << 20
  2097152: 'fieldHockey',     // 1L << 21
  4194304: 'workout',         // 1L << 22
  8388608: 'barbershop',      // 1L << 23
  16777216: 'squash',         // 1L << 24
  33554432: 'swimming',       // 1L << 25
  67108864: 'skate',          // 1L << 26
  134217728: 'climbing',      // 1L << 27
  268435456: 'snow',          // 1L << 28
  536870912: 'rent',          // 1L << 29
  1073741824: 'dance',        // 1L << 30
  2147483648: 'wrestling',     // 1L << 31
  4294967296: 'yoga',         // 1L << 32
  8589934592: 'cyber',        // 1L << 33
  17179869184: 'skiing',      // 1L << 34
  34359738368: 'bicycle',     // 1L << 35
  68719476736: 'extreme',     // 1L << 36
  137438953472: 'kickboxing', // 1L << 37
  274877906944: 'mma',        // 1L << 38
  549755813888: 'fighting',   // 1L << 39
  1099511627776: 'darts',     // 1L << 40
  2199023255552: 'other',     // 1L << 41
};

// Обратный маппинг - строковые ключи на числовые значения
export const sportKeysToFlags = {
  tableTennis: 1,
  basketball: 2,
  volleyball: 4,
  badminton: 8,
  paintball: 16,
  football: 32,
  hockey: 64,
  tennis: 128,
  boxing: 256,
  lasertag: 512,
  running: 1024,
  golf: 2048,
  pool: 4096,
  fitness: 8192,
  bowling: 16384,
  driving: 32768,
  rugby: 65536,
  americanFootball: 131072,
  chess: 262144,
  iceSkating: 524288,
  baseball: 1048576,
  fieldHockey: 2097152,
  workout: 4194304,
  barbershop: 8388608,
  squash: 16777216,
  swimming: 33554432,
  skate: 67108864,
  climbing: 134217728,
  snow: 268435456,
  rent: 536870912,
  dance: 1073741824,
  wrestling: 2147483648,
  yoga: 4294967296,
  cyber: 8589934592,
  skiing: 17179869184,
  bicycle: 34359738368,
  extreme: 68719476736,
  kickboxing: 137438953472,
  mma: 274877906944,
  fighting: 549755813888,
  darts: 1099511627776,
  other: 2199023255552,
};

export const sportsEnum = {
  tableTennis: 'Настольный теннис',
  basketball: 'Баскетбол',
  volleyball: 'Волейбол',
  badminton: 'Бадминтон',
  paintball: 'Пейнтбол',
  football: 'Футбол',
  hockey: 'Хоккей',
  tennis: 'Теннис',
  boxing: 'Бокс',
  lasertag: 'Лазертаг',
  running: 'Бег',
  golf: 'Гольф',
  pool: 'Бильярд',
  fitness: 'Фитнес',
  bowling: 'Боулинг',
  driving: 'Авто и мото',
  rugby: 'Регби',
  americanFootball: 'Американский футбол',
  chess: 'Шахматы',
  iceSkating: 'Каток',
  baseball: 'Бейсбол',
  fieldHockey: 'Хоккей на траве',
  workout: 'Воркаут',
  barbershop: 'Барбершоп "Men\'s Classic"',
  squash: 'Падел и Сквош',
  swimming: 'Плавание',
  skate: 'Скейтборд',
  climbing: 'Скалодром',
  snow: 'Лыжи и сноуборд',
  rent: 'Прокат снаряжения',
  dance: 'Танцы',
  wrestling: 'Борьба',
  yoga: 'Йога',
  cyber: 'Киберспорт',
  skiing: 'Беговые лыжи',
  bicycle: 'Велоспорт',
  extreme: 'Экстрим',
  kickboxing: 'Кикбоксинг',
  mma: 'ММА',
  fighting: 'Единоборства прочие',
  darts: 'Дартс',
  other: 'Другое',
};

export const sportCenterAlterEnum = {
  pool: 'Pool',
  snow: 'Snow',
  complex: 'Complex',
  rental: 'Rental',
};

export const workingHoursTypeEnum = {
  full: 'full',
  half: 'half',
  third: 'third',
};

export const workingHourPartTypeEnum = {
  all: 'all',
  left: 'left',
  right: 'right',
  middle: 'middle',
};

export const workingHourPartType = {
  all: 'Целая',
  left: 'Левая',
  right: 'Правая',
  middle: 'Средняя',
};

export const roleEnum = {
  user: 'user',
  admin: 'admin',
};
